import React, { useState } from 'react';
import {
  Container, Drawer, Group, Burger, Title, Anchor
} from '@mantine/core';
import PropTypes from 'prop-types';
import { useDisclosure } from '@mantine/hooks';
import { Link } from 'gatsby';

import * as classes from './HeaderSimple.module.css';

function Header({ location, menu, title, logo }) {
  const [opened, { toggle, close }] = useDisclosure(false);
  const [active, setActive] = useState(location?.pathname?.replace(/(.+)\/$/, '$1'));

  const menuList = menu.map(({ menuUrl: link, menuTitoloVisualizzato: label }) => {
    const isExternal = link.startsWith('https\:');

    if (isExternal) {
      return (
        <Anchor
          key={label}
          href={link}
          underline="never"
          target="_blank"
          className={classes.link}
        >
          {label}
        </Anchor>
      );
    }

    return (
      <Link
        key={label}
        to={link}
        className={classes.link}
        data-active={active === link || undefined}
        onClick={() => {
          close(false);
          setActive(link);
        }}
      >
        {label}
      </Link>
    );
  });

  // TODO: non harcodare nome app
  return (
    <header className={classes.header}>
      <Container size="md" className={classes.inner}>
        <Title order={1} className={classes.logostyle} aria-label="MathX">
          <span
            style={{
              zIndex: 0,
              top: '.5rem',
              position: 'fixed',
              overflow: 'hidden',
              width: '8rem',
              fontSize: '.5rem',
              height: '2.5rem',
            }}>
            MathX - esercizi di matematica e problemi online con soluzioni per le scuole superiori
          </span>
          <Link style={{
            top: '.5rem',
            backgroundColor: 'white',
            zIndex: 1,
            position: 'fixed',
            width: '8rem',
          }} to="/" aria-label="Torna alla Home Page" title="Torna alla Home Page">
            {logo}
          </Link>
        </Title>
        <Group gap={5} visibleFrom="xs">
          {menuList}
        </Group>

        <Burger opened={opened} onClick={toggle} hiddenFrom="xs" size="sm" />
        <Drawer opened={opened} onClose={close} title={title} className={classes.drawer}>
          {menuList}
        </Drawer>
      </Container>
    </header>
  );
}

Header.propTypes = {
  location: PropTypes.object,
  menu: PropTypes.array,
  title: PropTypes.string,
};

export default Header;
